import Users from '../components/Users/Users';

const HomePage = () => {
    return <>
        <Users />
    </>
};

export default HomePage;